import React, { useMemo } from 'react'
import { CheckboxSelector, CheckboxSelectorInner } from '@Knowledge-OTP/znk-ui-components'
import useTranslation from '../../../../i18n/useTranslation'
import usePaginatedServicesQuery from './Model/usePaginatedServicesQuery'
import { ordenateArrayByName } from '../../../../utils/ordenateArrayByName'
import FilterBadge from '../../../../common/FilterBadge'
const ServiceFilter = (props) => {
    const {label, setFilters = () => {}, filters = [], useInner = false} = props 
    const {translate} = useTranslation()
    const {data, loading} = usePaginatedServicesQuery(
        {limit: 0}
    )
    const services = useMemo(
      () => ordenateArrayByName(data?.paginatedServices?.docs) || [], [data]
    )
    const serviceOptions = services.map(item => ({ name: item.name, id: item.id }))
    const checkboxSelectorProps = {
      // setDataFilters={setStudentFilters}
      setDataFilters: setFilters,
      dataFilters: filters,
      direction: 'bottomLeft',
      loading: loading,
      data: serviceOptions,
      typeFilter: 'services',
      strings: {
        viewAll: translate('filters.plans.viewAll'),
        buttonCancel: translate('filters.plans.buttonCancel'),
        buttonApply: translate('filters.plans.buttonApply'),
        search: translate('filters.plans.search')
      }
    }
    return (
      useInner ?
      <CheckboxSelectorInner style={{maxWidth: 'auto'}} {...checkboxSelectorProps}/> :
      <CheckboxSelector {...checkboxSelectorProps}>
        <FilterBadge
          title={label || 'Services'}
          options={serviceOptions}
          selectedIds={filters}
          onClearFilters={() => setFilters([])}
        />
      </CheckboxSelector>
    )
}

export default ServiceFilter
